module.exports = __webpack_public_path__ + "img/APCSPMCexample.68ddae94.png";